export enum Socket {
  /* PUBLIC EVENTS */
  USER_CONNECTED = "USER_CONNECTED",
  USER_DISCONNECTED = "USER_DISCONNECTED",
  USER_PROFILE_EDITED = "USER_PROFILE_EDITED",
  USER_AVATAR_CHANGED = "USER_AVATAR_CHANGED",
  USER_PET_CHANGED = "USER_PET_CHANGED",
  USER_STATUS_CHANGED = "USER_STATUS_CHANGED",
  USER_STATUS_VACATION_ON = "USER_STATUS_VACATION_ON",
  USER_STATUS_VACATION_OFF = "USER_STATUS_VACATION_OFF",
  USER_WORK_IN_OFFICE_CHANGED = "USER_WORK_IN_OFFICE_CHANGED",
  USER_DISABLED = "USER_DISABLED",
  USER_PROFILE_IMAGE_UPDATED = "USER_PROFILE_IMAGE_UPDATED",
  USER_DELETED = "USER_DELETED",

  SPACE_SCENARIO_CHANGED = "SPACE_SCENARIO_CHANGED",
  SPACE_ENABLED = "SPACE_ENABLED",
  SPACE_DISABLED = "SPACE_DISABLED",
  SPACE_SPACE_EDITED = "SPACE_SPACE_EDITED",
  SPACE_IMAGE_UPDATED = "SPACE_IMAGE_UPDATED",
  SPACE_DELETED = "SPACE_DELETED",

  SCENARIO_ROOMS_EDITED = "SCENARIO_ROOMS_EDITED",
  SCENARIO_IMAGES_UPDATED = "SCENARIO_IMAGES_UPDATED",

  ROOM_JOIN_CHAT = "ROOM_JOIN_CHAT",
  ROOM_IMAGE_UPDATED = "ROOM_IMAGE_UPDATED",
  ROOM_WEBINAR_OPENED = "ROOM_WEBINAR_OPENED",
  ROOM_WEBINAR_CLOSED = "ROOM_WEBINAR_CLOSED",
  ROOM_VIDEO_URL_CHANGED = "ROOM_VIDEO_URL_CHANGED",
  ROOM_UPDATED = "ROOM_UPDATED",

  SPACE_USER_PERMISSIONS_CHANGED = "SPACE_USER_PERMISSIONS_CHANGED",
  SPACE_USER_DISABLED = "SPACE_USER_DISABLED",
  SPACE_USER_DELETED = "SPACE_USER_DELETED",
  SPACE_USER_TECHNICAL_INFO_REQUESTED = "SPACE_USER_TECHNICAL_INFO_REQUESTED",
  SPACE_USER_TECHNICAL_INFO_RECEIVED = "SPACE_USER_TECHNICAL_INFO_RECEIVED",
  SUPER_SPACE_USER_DELETED = "SUPER_SPACE_USER_DELETED",

  CONSOLE_MESSAGE = "CONSOLE_MESSAGE",

  REFRESH_BROWSER = "REFRESH_BROWSER",
  ROOM_SPEED_NETWORKING_MEET = "ROOM_SPEED_NETWORKING_MEET",
  ROOM_SPEED_NETWORKING_WAITING = "ROOM_SPEED_NETWORKING_WAITING",
  POSTER_UPDATED = "POSTER_UPDATED",
  POSTER_IMAGE_UPDATED = "POSTER_IMAGE_UPDATED",

  /* PRIVATE EVENTS */
  USER_RECEIVING_MEET = "USER_RECEIVING_MEET",
  ROOM_JOIN_MEETING = "ROOM_JOIN_MEETING",

  MAINTENANCE_ON = "MAINTENANCE_ON",
  MAINTENANCE_OFF = "MAINTENANCE_OFF",
  EXTEND_MAINTENANCE = "EXTEND_MAINTENANCE",
  NEXT_MAINTENANCE = "NEXT_MAINTENANCE",
  CANCEL_NEXT_MAINTENANCE = "CANCEL_NEXT_MAINTENANCE",

  SPACE_USER_UPDATE_POSITION = "SPACE_USER_UPDATE_POSITION",
  SPACE_EMOJI_REACTION = "SPACE_EMOJI_REACTION",

  SPACE_USER_UPDATE_POSITION_BY_ROOM = "SPACE_USER_UPDATE_POSITION_BY_ROOM",

  POWERUPS_DAILY_TASKS_NOTIFICATIONS = "POWERUPS_DAILY_TASKS_NOTIFICATIONS",
  POWERUPS_DAILY_TASKS_DONE_NOTIFICATIONS = "POWERUPS_DAILY_TASKS_DONE_NOTIFICATIONS",
  POWERUPS_VACATION_STATUS_NOTIFICATION = "POWERUPS_VACATION_STATUS_NOTIFICATION",
  POWERUPS_SEND_ONBOARDING_USER_NOTIFICATION = "POWERUPS_SEND_ONBOARDING_USER_NOTIFICATION",
  POWERUPS_READ_ONBOARDING_USER_NOTIFICATION = "POWERUPS_READ_ONBOARDING_USER_NOTIFICATION",
  POWERUPS_POLLS_NOTIFICATIONS = "POLLS_NOTIFICATIONS_POWERUPS",
  POWERUPS_ADMIN_NOTIFICATIONS_VACATION = "POWERUPS_ADMIN_NOTIFICATIONS_VACATION",
  POWERUPS_PHOTO_ALBUM_NOTIFICATIONS = "POWERUPS_PHOTO_ALBUM_NOTIFICATIONS",

  GLOBAL_PARAMS_UPDATED = "GLOBAL_PARAMS_UPDATED",

  POLL_CREATED = "POLL_CREATED",
  POLL_CLOSED = "POLL_CLOSED",
  POLL_VOTED = "POLL_VOTED",
  ROOM_RESERVE_STARTED = "ROOM_RESERVE_STARTED",
  ROOM_RESERVE_FINISHED = "ROOM_RESERVE_FINISHED",

  ASSASSIN_GAME_STARTED = "ASSASSIN_GAME_STARTED",
  ASSASSIN_GAME_FINISHED = "ASSASSIN_GAME_FINISHED",
  ASSASSIN_GAME_YOU_ARE_ASSASSIN = "ASSASSIN_GAME_YOU_ARE_ASSASSIN",
  ASSASSIN_GAME_ASSASSIN_WON = "ASSASSIN_GAME_ASSASSIN_WON",
  ASSASSIN_GAME_PLAYER_KILLED = "ASSASSIN_GAME_PLAYER_KILLED",
  ASSASSIN_GAME_PLAYER_REPORTED = "ASSASSIN_GAME_PLAYER_REPORTED",
  ASSASSIN_GAME_PLAYER_VOTED = "ASSASSIN_GAME_PLAYER_VOTED",
  ASSASSIN_GAME_POLL_CLOSED = 'ASSASSIN_GAME_POLL_CLOSED',
  ASSASSIN_GAME_PLAYERS_WON = 'ASSASSIN_GAME_PLAYERS_WON',
  ASSASSIN_YOU_HAVE_PENALTY_AND_CANNOT_REPORT = "ASSASSIN_YOU_HAVE_PENALTY_AND_CANNOT_REPORT",
}
